import React, { Component, Fragment } from 'react';
// import Paper from '@material-ui/core/Paper';

class Chat extends Component {

  render() {
    return (
      <Fragment>
        {/* <Paper className="project hide">
          <p>Press "Chat With Ian" in the bottom right!</p>
          <p>
            I will get back to you as soon as possible!p
          </p>
        </Paper>
        <div id="fixed-chat-notifier" className="pulse"></div> */}
      </Fragment>
    );
  }

}

export default Chat;



// WEBPACK FOOTER //
// ./src/components/Chat/Chat.js